export default {
  meta: {
    title: '一鸣决策报告',
    url: '/share', // 埋点字段，上报归属的模块
    urlName: '一鸣决策报告-分享' // 埋点字段，上报归属的模块
  }
};

